import { Container } from '@mui/material'
import { styled } from '@mui/material/styles';

export const BottomSheetContainer = styled(Container)({
  position: 'fixed', 
  bottom: 0, 
  left: 0, 
  right: 0, 
  background: 'white',
  boxShadow: '0px -2px 15px 0px rgba(145, 158, 171, 0.24)',
  borderRadius: '20px 20px 0 0',
  padding: 0
});